export default function () {
  // --------------------------------客户详情子级详情展示组件配置-------------------------
  const customerChildDetailComponent = {
    accident: 'accidentDetail',
    maintenance: 'maintenanceDetail',
    personalOrder: 'personalOrderDetail',
    enterpriseChildOrder: 'personalOrderDetail',
    enterpriseOrder: 'enterpriseOrderDetail',
    overdue: 'overdueDetail',
  }
  return {
    customerChildDetailComponent,
  }
}
